export default __webpack_public_path__ + "static/media/our vision.829ed187.svg";